import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import _ from 'lodash'
import throttle from 'lodash/throttle'
import DocumentTitle from 'react-document-title'
import { hideMenu } from 'react-contextmenu/modules/actions'
import {showNotification,hideNotification} from '../../actions/notifications'
import {loadInitialData} from '../../actions/initialData'
import {fetchQuestions,updateQuestionContent, updateQuestionMeta, newQuestion,deleteQuestion } from '../../actions/library/questions'
import {uploadNewImageToCloudinary} from '../../actions/cloudinary'
import {showMoveToFolderModal,showImageSearchModal,showGifSearchModal,hideModal,showConfirmModal} from '../../actions/modals'
import {isSurvey} from '../../utils/isSurvey'
import {updateQuestionWithFormValues} from '../../utils/editors/updateQuestionWithFormValues'
import {setToSurvey} from '../../utils/editors/setToSurvey'
import {setToGraded} from '../../utils/editors/setToGraded'
import {setToTrueFalse} from '../../utils/editors/setToTrueFalse'
import {convertToSet} from '../../utils/editors/convertToSet'
import {shuffleChoices} from '../../utils/editors/shuffleChoices'
import {makeACopyQuestion} from '../../utils/editors/makeACopy'
import QuestionEditor from '../../components/editors/QuestionEditor'
import {playItem} from '../../utils/playItem'
import update from 'immutability-helper'
import {saveImageSearchModalImage} from '../../actions/modals'
import {placeholderQuestion} from '../../utils/editors/questionTemplates'
import {copyQuestion} from '../../utils/copyPaste' 
import find from 'lodash/find'
import {updateQuestionLock,deleteLockForQuestion,synchronousDeleteLockForQuestion} from '../../actions/locks' 
import {repoPusherSetup} from '../../utils/pusher/repoPusherSetup'
import {showRepoSelectionModal } from '../../actions/modals'


const LOCK_THROTTLE_TIME=1000*10
const DEBOUNCE_TIME=1000 
const CONTEXT_MENU_CLOSE_DELAY = 150 
const emptyBodyText='Click here to edit question'
const shufflingTime=750
const shuffleDelay=375
const MAX_FILE_SIZE=20000000
 
 



class QuestionEditorContainer extends Component {
  
	constructor(props){
		super(props)
		
		this.createNewQuestion=this.createNewQuestion.bind(this)		
		this.handleEditFormOnChange=this.handleEditFormOnChange.bind(this)    
		this.handleChangeTemplate=this.handleChangeTemplate.bind(this)  
		this.uploadImage=this.uploadImage.bind(this)    
		this.handleSetToSurvey=this.handleSetToSurvey.bind(this)   
		this.handleSetToGraded=this.handleSetToGraded.bind(this)      
		this.showArchiveQuestionModal=this.showArchiveQuestionModal.bind(this)
		this.handleMakeACopy=this.handleMakeACopy.bind(this)
		this.handleArchiveQuestion=this.handleArchiveQuestion.bind(this)
		this.convertToSet=this.convertToSet.bind(this)
		this.saveChanges=this.saveChanges.bind(this)
		this.updateQuestion=this.updateQuestion.bind(this)
		this.updateFontSizes=this.updateFontSizes.bind(this)
		this.handleBodyOnChange=this.handleBodyOnChange.bind(this)
		this.handleChoiceOnChange=this.handleChoiceOnChange.bind(this)
		this.replaceImageSearchModal=this.replaceImageSearchModal.bind(this)
		this.handlePlayQuestion=this.handlePlayQuestion.bind(this)
		this.handleShuffleChoices=this.handleShuffleChoices.bind(this)
		this.clearTempImage=this.clearTempImage.bind(this)
		this.handleSetToTrueFalse=this.handleSetToTrueFalse.bind(this)
		this.handleAddChoice=this.handleAddChoice.bind(this)
		this.handleFileUpload=this.handleFileUpload.bind(this)
		this.handleCopyQuestion=this.handleCopyQuestion.bind(this)
		this.lockItem=this.lockItem.bind(this)
		this.shouldDeleteLock=this.shouldDeleteLock.bind(this)
		this.beforeUnload=this.beforeUnload.bind(this)
		this.handleLockedOut=this.handleLockedOut.bind(this)
		this.showImageSearchModal=this.showImageSearchModal.bind(this)




		this.delayedMenuClose = _.debounce(this.delayedMenuClose,CONTEXT_MENU_CLOSE_DELAY)
		this.saveChanges = _.debounce(this.saveChanges,DEBOUNCE_TIME,{'leading': false })
		this.lockItem = throttle(this.lockItem,LOCK_THROTTLE_TIME,{'edge': 'both' })


		this.promises=[]

		let parentFolder=null
		let repo=null

		if(typeof window.parentFolder === 'string'){//Prevent invalid folder value
			parentFolder=window.parentFolder
		}
		if(typeof window.repo === 'string'){//Prevent invalid repo value
			repo=window.repo
		}



		let question
		let isSurvey

		if(props.match.params.id !== 'newquestion'){
			question=null
			isSurvey=false
		}else{

			isSurvey=false

			//use '\n' instead of '' so we can distinguish between a field never edited and one that has been edited to blank


			question = {...placeholderQuestion(),
				'folder': parentFolder,
				'repo':repo,
				'archived': false,
				'createdOnMobile':false,
				'version':0
			}
 


		
		}


		this.state={
			questionTemplate:'standard',
			isSurvey:isSurvey,
			uploadedFileCloudinaryUrl: '',
			lastSaved:null,
			isSaving:false,
			unableToSave:false,
			uploadingToCloudinary:false,
			tempImage:null,
			question:question,
			hasImage:false,
			imageSearchTerm:null,
			imageSearchResults:null,
			isShuffling:false,
			userLockedSet:false


		}
	}

	componentDidMount(){
		window.addEventListener('beforeunload', this.beforeUnload)
		let loadState='Edit'
		if(this.props.match.params.id === 'newquestion'){
			loadState='New'
		}
		if(window.analytics){
			window.analytics.page('Item Editor',{itemType:'Question',loadState:`${loadState}`})
		}
	}
	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.beforeUnload)
		this.props.hideNotification()
		this.props.loadInitialData(this.props.currentUser.id)
		
		const shouldDeleteLock = this.shouldDeleteLock()
		if(shouldDeleteLock){
			this.props.deleteLockForQuestion(this.props.match.params.id)
			this.lockItem.cancel()
		}
	}	


	UNSAFE_componentWillReceiveProps(nextProps) {
		if(!this.props.parentRepo && nextProps.parentRepo && nextProps.parentRepo.shared){
			repoPusherSetup(nextProps.parentRepo.id)
		}


		if(this.state.question === null && nextProps.currentQuestion) {
			let hasImage=true
			let nextQuestion=nextProps.currentQuestion
			if(nextProps.currentQuestion.image ===''){
				hasImage=false
			}

			if(!nextQuestion.xLayout){
				const xLayoutVersion=parseInt(process.env.REACT_APP_XLAYOUT_VERSION,10)
				nextQuestion.xLayout={'version':xLayoutVersion}
			}
			this.setState({
				question:nextQuestion, 
				isSurvey:isSurvey(nextProps.currentQuestion),
				hasImage:hasImage
			})
		}

		if(!this.props.itemIsLockedByAnotherUser && nextProps.itemIsLockedByAnotherUser){
			this.handleLockedOut()
		}


		if(this.props.itemIsLockedByAnotherUser && this.props.currentQuestion !== nextProps.currentQuestion){
			let hasImage=true
			let nextQuestion=nextProps.currentQuestion
			if(nextProps.currentQuestion.image ===''){
				hasImage=false
			}

			if(!nextQuestion.xLayout){
				const xLayoutVersion=parseInt(process.env.REACT_APP_XLAYOUT_VERSION,10)
				nextQuestion.xLayout={'version':xLayoutVersion}
			}
			this.setState({
				question:nextQuestion, 
				isSurvey:isSurvey(nextProps.currentQuestion),
				hasImage:hasImage
			})
		}


		//upload image selected from modal
		if(this.props.uploadingImage !== nextProps.uploadingImage && nextProps.uploadingImage) {
			this.setState({
				tempImage: nextProps.thumbnail,
				hasImage:true,
				imageSearchTerm:nextProps.imageSearchTerm,
				imageSearchResults:nextProps.imageSearchResults
			})
			this.uploadImage(nextProps.uploadingImage,nextProps.thumbnail)
		}

		if(this.props.currentUserPermission && !nextProps.currentUserPermission){
			this.props.history.push('/library') //if permission is deleted for current user for repo that item they are editing is in then redirect to library
		}
	}


	handleLockedOut(){
		this.props.hideModal()
		//blur inputs when locked out
		var tmp = document.createElement('input')
 		document.body.appendChild(tmp)
		tmp.focus()
 		document.body.removeChild(tmp)
	}


	 beforeUnload() { 
	 	const shouldDeleteLock = this.shouldDeleteLock()
	 	if(shouldDeleteLock){
	 		this.props.synchronousDeleteLockForQuestion(this.props.match.params.id)
		 }
	 }	



	 shouldDeleteLock(){
	 	if(this.state.userLockedSet){
	 			return true
	 	}else{
	 		if(this.props.lock && this.props.currentQuestion && this.props.currentQuestion.repo && !this.props.itemIsLockedByAnotherUser ){
	 			return true
	 		}
	 		else{
	 			return false
	 		}
	 		
	 	}

	 }



	lockItem(){
		if(this.props.currentQuestion && this.props.currentQuestion.repo){
			this.setState({userLockedSet:true})
			this.props.updateQuestionLock(this.props.match.params.id)
		}
	}



	handleCopyQuestion(){
		copyQuestion(this.props.currentQuestion)
		const notificationMessage='to Clipboard'
		this.props.showNotification(notificationMessage,'Copied','default')
	}

	handleMakeACopy(){
		this.lockItem()
		// const question=this.props.currentQuestion
		return this.props.makeACopyQuestion(this.props.currentQuestion).then((response) => {
			window.open(`/editor/${response.id}`, '_blank')
		})
	}

	showArchiveQuestionModal(){
		this.props.showConfirmModal(this.state.question.body,this.handleArchiveQuestion,'trash')
	}


	handleArchiveQuestion(){
		const nowDate = new Date()
	  const requestData = {
	        ...this.props.currentQuestion,
	        clientModified: nowDate,
	        archived: true
	    }
	 return this.props.updateQuestionMeta(requestData,this.props.currentQuestion.id).then(() => {
	  this.props.hideModal()
	   this.props.history.push('/recent')	
	 })
	}


 
	uploadImage(img,thumbnail) {
		this.lockItem()
		this.setState({
			uploadingToCloudinary: true,
		})
		this.props.hideModal()
		return this.props.uploadNewImageToCloudinary(img,thumbnail).then((response) => {
			this.handleEditFormOnChange(response.public_id, 'image',null)
	
		 })
		 .catch((error) => {
		 	this.clearTempImage()
		 })
	}

	clearTempImage(){
		this.setState({tempImage:null})
	}


	//A new set is created on the first edit made in setEditor.  
	//if the first edit is to add a question to the set, it will be created with 2 questions
	createNewQuestion(question) {
		this.setState({isSaving:true,unableToSave:false})
		const nowDate = new Date()
		const requestData = {
			...question,
			'clientModified': nowDate,
			'userCreated':nowDate,	
			'lastEditedAt':nowDate,			
		}


		return this.props.newQuestion(requestData).then((response) => {

			this.props.history.push(`./${response.id}`)
			this.setState({isSaving:false, lastSaved:response.clientModified,unableToSave:false,question:{...question,id:response.id}})
			
			if(response.repo){
				this.props.updateQuestionLock(response.id)
				this.setState({userLockedSet:true})
			}
			
			return null
		})
			.catch(error => {

				this.setState({isSaving:false, unableToSave:true})
				this.promises=[]
			})
	}



	handleEditFormOnChange(value,field,index){
		this.lockItem()
		let {question} = this.state
		 if(field==='removeChoice' && question.choices[index].correct){
			this.setState({isSurvey:true})
		}
		if(field==='radio'){
			if(value==='false'){
				this.setState({isSurvey:false})			//if setting a choice to correct the question is no longer a surver
			}
			else if(value==='true'){
				this.setState({isSurvey:true})				//if setting a corect choice to incorrect it becomes a survey
				//const notificationMessage=`Changed ${question.body} to Survey`
				//this.props.showNotification(notificationMessage,'green')
			}		
		}

		if(field ==='image' && value===''){
			this.setState({hasImage:false,tempImage:null})
		}	
		if(field ==='image' && value!==''){
			this.setState({hasImage:true})
		}	
		const updatedQuestion= updateQuestionWithFormValues(value,field,index,question)
		this.setState({question:updatedQuestion,uploadingToCloudinary:false})
		//this.state.question=updatedQuestion
		this.saveChanges()
	}


	handleShuffleChoices(){
		this.lockItem()
		if(!this.state.isShuffling){
			this.setState({isShuffling:true})
			this.setState({isShufflingStart:true})
			setTimeout(() => {
	            this.setState({
	            isShuffling:false
	          })
	        }, shufflingTime)

			setTimeout(() => {
	            this.setState({
	            isShufflingStart:false
	          })
	        }, shufflingTime/2)
			

			setTimeout(() => {
		    const oldChoices=this.state.question.choices.slice()
				const newChoices=shuffleChoices(oldChoices)
				const nowDate=new Date()
				const updatedQuestion= update(this.state.question, 
					{choices: 
						{$set: newChoices}				
						,
					clientModified: {$set: nowDate}
					})
				this.setState({question:updatedQuestion})
				this.saveChanges()      
	       }, shuffleDelay)
		}
	}


	handleBodyOnChange(value){
		this.lockItem()
		const nowDate=new Date()
		let body=value

		if(value==='' && this.state.question.image===''){
			body=emptyBodyText
		}
		const updatedQuestion= update(this.state.question, {body: {$set: body},clientModified: {$set: nowDate}})
 		this.setState({question:updatedQuestion})
		this.saveChanges()
	}

	handleChoiceOnChange(value,index){
		this.lockItem()
		const nowDate=new Date()
		const updatedQuestion= update(this.state.question, 
			{choices: 
				{[index]:{
					body:{$set: value}
				}
				},
			clientModified: {$set: nowDate}
			})
		this.setState({question:updatedQuestion})
		this.saveChanges()
	}
 

	updateFontSizes(field,value,bodyHeight){
		if(!this.props.itemIsLockedByAnotherUser){
			if(field==='body'){
			   this.setState(function(prevState, props){
			      return {question: {...prevState.question,xLayout:{...prevState.question.xLayout,bodyH:bodyHeight,bodyFS:value}}}
			   })
			
			}
			else if(field==='choices'){
			   this.setState(function(prevState, props){
			      return {question: {...prevState.question,xLayout:{...prevState.question.xLayout,choiceFS:value}}}
			   })
			}
			this.saveChanges()
		}
	}

	


	updateQuestion(question){
		this.setState({isSaving:true,unableToSave:false})

		return this.props.updateQuestionContent(question,question.id).then((response)=>{

			if(response==='failed'){
				this.setState({unableToSave:true})
			}else{
				this.setState({isSaving:false, lastSaved:response.clientModified,unableToSave:false})
			}	
		})
	}
 


	saveChanges(){
		let isViewOnly=false
		if(this.props.parentRepo && (this.props.parentRepo.role === 'viewer'|| this.props.parentRepo.role === 'consumer')){
  			isViewOnly = true
  		}
  		if(!isViewOnly && !this.props.itemIsLockedByAnotherUser){

			const {question}=this.state
			const nowDate=new Date()
			question.clientModified=nowDate
			if(!question.id){//only create the question once
				if(this.promises.length===0){
					this.promises.push(this.createNewQuestion(question))
				}
				//if you make additional changed after you have started creating the question then wait until it is created to update it 
				else{ Promise.all(this.promises).then(function () {
					this.updateQuestion(this.state.question)		
				}.bind(this))
				}
			}else{
				this.updateQuestion(question)		
			}
		}
	}

	handleSetToSurvey(){
		this.lockItem()
		this.setState({isSurvey:true})
		const surveyQuestion=setToSurvey(this.state.question)
		this.setState({question:surveyQuestion})
		this.saveChanges()
	}


	handleSetToGraded(){
		this.lockItem()
		this.setState({isSurvey:false})
		const gradedQuestion=setToGraded(this.state.question)
		this.setState({question:gradedQuestion})
		this.saveChanges()
	}

	handleSetToTrueFalse(){
		this.lockItem()
		const trueFalseQuestion=setToTrueFalse(this.state.question)
		this.setState({question:trueFalseQuestion,isSurvey:false})
		this.saveChanges()
	}


	handleAddChoice(){
		this.lockItem()
		if(this.state.question.choices.length<4){
			const	updatedQuestion=update(this.state.question,
				{choices:  
					{$push: [{correct:false, body:''}]
					}})
			this.setState({question:updatedQuestion})
			this.saveChanges()
		}
	}

	handleChangeTemplate(newTemplate){
		this.lockItem()
		const nowDate=new Date()
		const updatedQuestion= update(
			this.state.question, 
			{template: 
				{$set: newTemplate}},
			{clientModified: {$set: nowDate}})
 		this.setState({question:updatedQuestion})
		this.saveChanges()
	}


	convertToSet(){
	  this.props.convertToSet(this.state.question)

	  .then((response) => {
	  // 	//window.location=`/seteditor/${response.id}`
	 	 this.props.history.push(`/seteditor/${response.id}`)


	  })
	}

	// handleCopyQuestion(){
	// 	props.copyQuestion(this.state.question)
	// 	alert('question copied')
	// }


	delayedMenuClose(){
		hideMenu()
	}

	handlePlayQuestion(sectionId){
		this.props.playItem(this.state.question,sectionId).then(() => {
			this.props.history.push('/liveview')		
		})		
	}     

	replaceImageSearchModal(){
		this.props.showImageSearchModal(this.state.imageSearchTerm,this.state.imageSearchResults)
	}


	handleFileUpload(e){
		const fileList = e.target.files
		const file = fileList[0]
		if(file && (file.size > MAX_FILE_SIZE)){
			this.props.hideModal()
			this.props.showNotification('Max image upload is 20mb','Cannot upload image','destroy')

		}else{
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = (event) => {
				this.props.saveImageSearchModalImage(event.target.result,event.target.result)
			}
		}
	}


	showImageSearchModal(){
		this.props.showImageSearchModal()
		this.lockItem()
	}



	render() {
  	let documentTitle = 'Question Editor'
		if(this.state.question){
			documentTitle=this.state.question.body || 'Untitled Question'
		}

		let isViewOnly = false
	  	if(this.props.parentRepo && (this.props.parentRepo.role === 'viewer'||this.props.parentRepo.role === 'consumer')){
	  		isViewOnly = true
	  	}

		return (
			<DocumentTitle title={documentTitle}>
				<div className='itemEditorContainer'>
					{this.state.question &&
					<QuestionEditor 
						isViewOnly={isViewOnly}
						parentRepo={this.props.parentRepo}
						permissions={this.props.permissions}
						isNewQuestion={this.props.match.params.id === 'newquestion'}
						copyQuestion={this.handleCopyQuestion}
						question={this.state.question}
						currentQuestion={this.props.currentQuestion}
						template={this.state.question.template}
						isSurvey={this.state.isSurvey}
						hasImage={this.state.hasImage}
						lastSaved={this.state.lastSaved}
						isSaving={this.state.isSaving}
						unableToSave={this.state.unableToSave}
						showMoveToFolderModal={this.props.showMoveToFolderModal}
						makeACopy={this.handleMakeACopy}
						archiveQuestion={this.showArchiveQuestionModal}
						showKeyboardShortcutsModal={this.props.showKeyboardShortcutsModal}			
						editFormOnChange={this.handleEditFormOnChange}
						changeTemplate={this.handleChangeTemplate}
						showImageSearchModal={this.showImageSearchModal}
						replaceImageSearchModal={this.replaceImageSearchModal}
						showGifSearchModal={this.props.showGifSearchModal}
						uploadingToCloudinary={this.state.uploadingToCloudinary}
						tempImage={this.state.tempImage}
						setToSurvey={this.handleSetToSurvey}
						setToGraded={this.handleSetToGraded}
						convertToSet={this.convertToSet}
						updateFontSizes={this.updateFontSizes}
						handleBodyOnChange={this.handleBodyOnChange}
						handleChoiceOnChange={this.handleChoiceOnChange}
						sections={this.props.sections}
						playItemForSection={this.handlePlayQuestion}
						shuffleChoices={this.handleShuffleChoices}
						isShuffling={this.state.isShuffling}
						isShufflingStart={this.state.isShufflingStart}
						clearTempImage={this.clearTempImage}
						setToTrueFalse={this.handleSetToTrueFalse}
						addChoice={this.handleAddChoice}
						disableTemplates={this.props.disableTemplates}
						disableImageSearch={this.props.disableImageSearch}
						saveImageSearchModalImage={this.props.saveImageSearchModalImage}
						handleFileUpload={this.handleFileUpload}
						lock={this.props.lock}
						itemIsLockedByAnotherUser={this.props.itemIsLockedByAnotherUser} 
						showRepoSelectionModal={this.props.showRepoSelectionModal}
					/>
					}
				</div>
   		</DocumentTitle>
		)
	}
}




function mapStateToProps(state,ownProps) {
	const currentQuestion=find(state.questions, {'id':ownProps.match.params.id})
	let parentRepo
	let permissions
	let lock = null
	let itemIsLockedByAnotherUser = false
	let repoId
	let currentUserPermission


	if(currentQuestion && currentQuestion.repo){
		repoId = currentQuestion.repo
	}else{
		if(typeof window.repo === 'string'){//Prevent invalid folder value
			repoId=window.repo
		}
	}


	if(repoId && currentQuestion){
		parentRepo = find(state.repos, {'id':repoId})
		const repoLocks = state.locks[repoId]

		lock = find(repoLocks, function(lock) {
    		return lock.item === currentQuestion.id
		})

		if(lock && state.user){
			if(lock.user !== state.user.id){
				itemIsLockedByAnotherUser = true
			}


		}

		permissions=state.permissions[repoId]
		const currentUser=state.user


		if(permissions && currentUser.id){
			const indexOfCurrentUserPermission = permissions.findIndex(permission => {
				if(permission.user){
					return permission.user.id === currentUser.id
				}else return  permission.originalEmail === currentUser.email
			})

			currentUserPermission=permissions[indexOfCurrentUserPermission]
		}
	}





	return {
		currentUser:state.user,
		currentUserPermission:currentUserPermission,
		itemIsLockedByAnotherUser:itemIsLockedByAnotherUser,
		lock:lock,
		currentQuestion:currentQuestion,
		parentRepo:parentRepo,
		permissions:permissions,
		sections:state.sections,
		uploadingImage:state.modals.image,
		thumbnail:state.modals.thumbnail,
		imageSearchTerm:state.modals.imageSearchTerm,
		imageSearchResults:state.modals.imageSearchResults,
		copiedQuestion:state.copiedQuestion,
		queueQuestionPolls:state.queueQuestionPolls,
		currentModal:state.modals.currentModal,
		disableTemplates:state.planRestrictions.disableTemplates,
		disableImageSearch:state.planRestrictions.disableImageSearch,

	  }
}




export default withRouter(connect(
	mapStateToProps,
	{
		setToTrueFalse,
		playItem,
		showNotification,
		hideNotification,
		fetchQuestions,
		convertToSet,
		makeACopyQuestion,
		showMoveToFolderModal,
		updateQuestionContent,
		updateQuestionMeta,
		deleteQuestion,
		showConfirmModal,
		newQuestion, 
		showImageSearchModal,
		showGifSearchModal,
		uploadNewImageToCloudinary,
		saveImageSearchModalImage,
		hideModal,
		updateQuestionLock,
		deleteLockForQuestion,
		synchronousDeleteLockForQuestion,
		loadInitialData,
		showRepoSelectionModal,

	}
)(QuestionEditorContainer))

